import { Translations } from "../types";

export const zh: Translations = {
  common: {
    upload: "上传",
    remove: "移除",
    replace: "替换",
    choose: "选择",
    file: "文件",
    files: "文件",
    title: "定制贴纸",
  },

  preview: {
    title: "图片预览",
    uploadTitle: "上传贴纸图片",
    fileTypes: "PNG, JPG 文件",
    chooseFile: "选择文件",
  },

  sections: {
    shapeAndSize: "形状和尺寸",
    material: "材质",
    model: "模型",
    stickerPreview: "贴纸预览",
  },

  shapes: {
    rectangle: "矩形",
    circle: "圆形",
    contour: "轮廓",
  },

  materials: {
    glossy: "光泽",
    glossyDesc: "高光泽表面",
    matte: "磨砂",
    matteDesc: "无反光表面",
    translucent: "半透明",
    translucentDesc: "半透明效果",
  },

  models: {
    coffeeMug: "咖啡杯",
    bassGuitar: "贝斯吉他",
    zippoLighter: "Zippo 打火机",
  },

  categories: {
    drinkware: "餐具",
    instruments: "乐器",
    accessories: "配件",
  },

  units: {
    mm: "毫米",
    cm: "厘米",
  },

  toolbar: {
    focusMode: "聚焦模式",
    focusModeDesc: "点击模型聚焦查看细节",
    stickerMode: "贴图模式",
    stickerModeDesc: "点击模型进行贴图操作",
    textureMode: "纹理模式",
    textureModeDesc: "将贴纸绘制到模型纹理上",
    decalMode: "贴花模式",
    decalModeDesc: "将贴纸投射到模型表面",
    resetCamera: "重置视角",
    resetCameraDesc: "回到默认相机位置",
  },

  canvasPreview: {
    desc: "实时显示贴纸在纹理上的位置",
  },
};
